import Cookies from 'js-cookie';
import { ACCESS_TOKEN_NAME } from '../../../utils/constants';

export const checkAuthentication = () => {
  const hasAccessToken = !!Cookies.get(ACCESS_TOKEN_NAME);
  return hasAccessToken;
};
